export class RoleModal {
    roleid: number;
    rolename: string;
}
